import http from "@/http";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("observatorio"),
    user: JSON.parse(localStorage.getItem("observatorio-user")),
    status: "",
  },
  mutations: {
    AUTH_REQUEST: (state) => {
      state.status = "loading";
    },
    AUTH_SUCCESS: (state, user) => {
      state.status = "success";
      state.token = user.token;
      state.user = user.user;
    },
    AUTH_ERROR: (state) => {
      state.status = "error";
    },
    AUTH_LOGOUT: (state) => {
      state.status = "";
      state.token = "";
      state.user = {};
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    AUTH_REQUEST: ({ commit, dispatch }, user) => {
      http
        .post("/sessions/admin", user)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          // se n tiver token tem que dar um throw error
          // e fazer um catch no Login.vue
          if (response.data.token) {
            localStorage.setItem("observatorio", response.data.token);
            localStorage.setItem(
              "observatorio-user",
              JSON.stringify(response.data.user)
            );
            http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${response.data.token}`;
            let userData = {
              user: response.data.user,
              token: response.data.token,
            };
            commit("AUTH_SUCCESS", userData);
            router.push("/admin");
          } else {
            throw "Problema na autenticação";
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          // commit("AUTH_LOGOUT");
          localStorage.removeItem("observatorio");
          // router.push("/login");
        });
    },
    // eslint-disable-next-line no-unused-vars
    AUTH_LOGOUT: ({ commit, dispatch }) => {
      localStorage.removeItem("observatorio");
      localStorage.removeItem("observatorio-user");
      commit("AUTH_LOGOUT");
      delete http.defaults.headers.common["Authorization"];
      router.push("/login");
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
  modules: {},
};
